/* 
 * DebugToolsMenu.js
 * Created on 8-dec-2016
 * @author Swen Meeuwes for &ranj
 */

import * as dat from 'dat.gui';

export default class DebugToolsMenu {
    constructor() {
        this._items = {};
        this._gui = new dat.GUI({name: "Debug menu", closeOnTop:true});
        this._gui.close();
        this._gui.width = 140;
        this._gui.domElement.parentElement.style.zIndex = 999;
    }

    addModule(displayName, module) {
        const callback = module.showPopup.bind(module);
        this._items[displayName] = callback;
        const controller = this._gui.add(this._items, displayName);
        //hacky method to avoid button labels being truncated
        const elem = controller.domElement.parentElement.children[0];
        elem.style.width = "90%";
    }

    destroy() {}
}
